import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const baseStyles = xcss({
	height: '40px',
	width: '44px',
	borderRadius: 'radius.small',
	border: 'none',
});

const placeholderStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

export const PlaceholderThumbnail = () => {
	return <Box xcss={[baseStyles, placeholderStyles]} testId="image-picker-placeholders" />;
};
